"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMDeclarationCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../../interfaces/vm-transformers/IVMScopeManager");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../../node/NodeGuards");
const VMConstants_1 = require("../../../VMConstants");
let VMDeclarationCompiler = class VMDeclarationCompiler {
    compileVariableDeclaration(node, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        for (const declarator of node.declarations) {
            if (NodeGuards_1.NodeGuards.isIdentifierNode(declarator.id)) {
                const varName = declarator.id.name;
                const isBlockScoped = node.kind === 'let' || node.kind === 'const';
                let scopedKey;
                let localIndex;
                let alreadyHoisted = false;
                const shadowsParameter = !isBlockScoped && context.parameters.has(varName);
                if (isBlockScoped) {
                    scopedKey = (0, VMConstants_1.getScopedVariableName)(varName, context.blockScopeDepth);
                    localIndex = this.vmCompilerUtils.getNextLocalIndex(context);
                }
                else if (shadowsParameter) {
                    localIndex = context.parameters.get(varName);
                    scopedKey = varName;
                    alreadyHoisted = true;
                }
                else {
                    scopedKey = varName;
                    if (!context.localVariables.has(scopedKey)) {
                        localIndex = context.localVariables.size;
                        context.localVariables.set(scopedKey, localIndex);
                    }
                    else {
                        localIndex = context.localVariables.get(scopedKey);
                        alreadyHoisted = true;
                    }
                }
                if (declarator.init) {
                    (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(declarator.init);
                }
                else if (!alreadyHoisted) {
                    builder.pushUndefined();
                }
                else {
                    continue;
                }
                if (isBlockScoped) {
                    context.variableScopes.set(scopedKey, { depth: context.blockScopeDepth, index: localIndex });
                    context.localVariables.set(scopedKey, localIndex);
                    (_b = context.activeBlockScopes) === null || _b === void 0 ? void 0 : _b.add(scopedKey);
                }
                let shadowsExistingPerIterationVar = false;
                if (((_c = context.perIterationLoopVars) === null || _c === void 0 ? void 0 : _c.has(varName)) && context.blockScopeDepth > 1) {
                    for (let d = context.blockScopeDepth - 1; d >= 0; d--) {
                        const lowerScopedKey = (0, VMConstants_1.getScopedVariableName)(varName, d);
                        if (context.variableScopes.has(lowerScopedKey) ||
                            context.localVariables.has(lowerScopedKey) ||
                            (d === 0 && context.localVariables.has(varName))) {
                            shadowsExistingPerIterationVar = true;
                            break;
                        }
                    }
                    if (!shadowsExistingPerIterationVar && context.envVars.has(varName)) {
                        const parameterWasShadowed = context.parameters.has(varName);
                        if (parameterWasShadowed) {
                            shadowsExistingPerIterationVar = true;
                        }
                    }
                }
                const isPerIterationLoopVar = ((_e = (_d = context.perIterationLoopVars) === null || _d === void 0 ? void 0 : _d.has(varName)) !== null && _e !== void 0 ? _e : false) &&
                    !shadowsExistingPerIterationVar;
                if (isPerIterationLoopVar && isBlockScoped) {
                    if (!context.perIterationVarScopedKeys) {
                        context.perIterationVarScopedKeys = new Set();
                    }
                    context.perIterationVarScopedKeys.add(scopedKey);
                }
                let shadowsInSameEnv = false;
                if (context.blockScopeDepth === 1 && context.envDepth === 1) {
                    const depth0Key = (0, VMConstants_1.getScopedVariableName)(varName, 0);
                    const hasAtDepth0 = context.variableScopes.has(depth0Key) ||
                        context.variableScopes.has(varName);
                    if (hasAtDepth0 && context.envVars.has(varName)) {
                        shadowsInSameEnv = true;
                    }
                }
                const usesScopedKey = isBlockScoped &&
                    (context.blockScopeDepth > 1 || shadowsInSameEnv) &&
                    !isPerIterationLoopVar;
                const envKey = usesScopedKey ? scopedKey : varName;
                const isNFEShadowing = varName === context.functionName && !isBlockScoped;
                const isEnvVar = !isNFEShadowing &&
                    (context.envVars.has(envKey) ||
                        (!shadowsExistingPerIterationVar && context.envVars.has(varName)) ||
                        (isPerIterationLoopVar && ((_g = (_f = context.perIterationLoopVars) === null || _f === void 0 ? void 0 : _f.has(varName)) !== null && _g !== void 0 ? _g : false)));
                if (isEnvVar) {
                    const nameIndex = context.constantPool.add(envKey);
                    const isConst = node.kind === 'const';
                    if (context.envDepth > 0 && isBlockScoped) {
                        if (isConst) {
                            builder.storeToCurrentEnvConst(nameIndex);
                        }
                        else {
                            builder.storeToCurrentEnv(nameIndex);
                        }
                    }
                    else if (isConst) {
                        builder.storeToEnvConst(nameIndex);
                    }
                    else {
                        if (isBlockScoped) {
                            builder.storeToCurrentEnv(nameIndex);
                        }
                        else {
                            builder.storeToEnv(nameIndex);
                        }
                    }
                }
                else if (shadowsParameter) {
                    builder.storeArg(localIndex);
                }
                else {
                    const actualIndex = this.vmCompilerUtils.getActualLocalIndex(localIndex, context);
                    builder.storeLocal(actualIndex);
                    if (node.kind === 'const') {
                        context.constLocalVariables.add(actualIndex);
                    }
                }
                if (isBlockScoped) {
                    this.scopeManager.exitLocalTDZ(context, varName);
                }
            }
            else if (NodeGuards_1.NodeGuards.isArrayPatternNode(declarator.id) || NodeGuards_1.NodeGuards.isObjectPatternNode(declarator.id)) {
                if (declarator.init) {
                    (_h = context.dispatch) === null || _h === void 0 ? void 0 : _h.expression(declarator.init);
                }
                else {
                    builder.pushUndefined();
                }
                const previousDeclarationKind = context._declarationKind;
                context._declarationKind = node.kind;
                (_j = context.dispatch) === null || _j === void 0 ? void 0 : _j.destructuring(declarator.id, false);
                context._declarationKind = previousDeclarationKind;
                if (node.kind === 'let' || node.kind === 'const') {
                    this.vmCompilerUtils.extractIdentifiersFromPattern(declarator.id).forEach((varName) => {
                        this.scopeManager.exitLocalTDZ(context, varName);
                    });
                }
            }
        }
    }
    compileFunctionDeclaration(node, context) {
        var _a, _b;
        if (!node.id) {
            return;
        }
        const funcName = node.id.name;
        if (context.blockScopeDepth === 0 && context.hoistedFunctionDeclarations.has(funcName)) {
            return;
        }
        const isBlockScoped = context.blockScopeDepth > 0;
        const scopedKey = isBlockScoped
            ? (0, VMConstants_1.getScopedVariableName)(funcName, context.blockScopeDepth)
            : funcName;
        let localIndex;
        if (!context.localVariables.has(scopedKey)) {
            localIndex = context.localVariables.size;
            context.localVariables.set(scopedKey, localIndex);
            if (isBlockScoped) {
                context.variableScopes.set(scopedKey, { depth: context.blockScopeDepth, index: localIndex });
                (_a = context.activeBlockScopes) === null || _a === void 0 ? void 0 : _a.add(scopedKey);
            }
        }
        else {
            localIndex = context.localVariables.get(scopedKey);
        }
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.functionExpression(node);
        const isEnvVar = context.envVars.has(funcName);
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (isEnvVar) {
            const actualIndex = this.vmCompilerUtils.getActualLocalIndex(localIndex, context);
            builder.dup();
            builder.storeLocal(actualIndex);
            const nameIndex = context.constantPool.add(funcName);
            builder.storeToCurrentEnv(nameIndex);
        }
        else {
            const actualIndex = this.vmCompilerUtils.getActualLocalIndex(localIndex, context);
            builder.storeLocal(actualIndex);
        }
    }
};
exports.VMDeclarationCompiler = VMDeclarationCompiler;
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils),
    __metadata("design:type", typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object)
], VMDeclarationCompiler.prototype, "vmCompilerUtils", void 0);
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager),
    __metadata("design:type", typeof (_b = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _b : Object)
], VMDeclarationCompiler.prototype, "scopeManager", void 0);
exports.VMDeclarationCompiler = VMDeclarationCompiler = __decorate([
    (0, inversify_1.injectable)()
], VMDeclarationCompiler);
